/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iupac_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The converter uppercases the motif, so the resulting pattern matches uppercase sequence. Add a case-insensitive flag in your regex engine if you need to match lowercase bases too.`)
};

const es_iupac_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El conversor pone el motivo en mayúsculas, así que el patrón resultante coincide con secuencia en mayúsculas. Añade un indicador de no distinción de mayúsculas y minúsculas en tu motor de regex si también necesitas coincidir con bases en minúsculas.`)
};

const de_iupac_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Konverter wandelt das Motiv in Großbuchstaben um, sodass das resultierende Muster auf Großbuchstaben-Sequenzen passt. Fügen Sie in Ihrer Regex-Engine ein Flag für Groß-/Kleinschreibungsunabhängigkeit hinzu, wenn Sie auch Kleinbuchstaben-Basen erfassen möchten.`)
};

const nl_iupac_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De converter zet het motief om in hoofdletters, dus het resulterende patroon matcht sequenties in hoofdletters. Voeg een hoofdletterongevoelige vlag toe in je regex-engine als je ook kleine letters wilt matchen.`)
};

const fr_iupac_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le convertisseur met le motif en majuscules, donc le motif résultant correspond à une séquence en majuscules. Ajoutez un indicateur insensible à la casse dans votre moteur regex si vous devez aussi faire correspondre des bases en minuscules.`)
};

const it_iupac_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il convertitore trasforma il motivo in maiuscolo, quindi il pattern risultante corrisponde a sequenze maiuscole. Aggiungi un flag case-insensitive nel tuo motore di espressioni regolari se devi corrispondere anche basi minuscole.`)
};

const pt_br2_iupac_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O conversor coloca o motivo em maiúsculas, então o padrão resultante corresponde a sequências em maiúsculas. Adicione uma flag de não diferenciação de maiúsculas/minúsculas no seu mecanismo de regex se também precisar corresponder a bases em minúsculas.`)
};

const pt_iupac_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O conversor converte o motivo para maiúsculas, pelo que o padrão resultante corresponde a sequências em maiúsculas. Adicione uma flag de insensibilidade a maiúsculas/minúsculas no seu motor de regex se também precisar de corresponder a bases em minúsculas.`)
};

const ja_iupac_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変換ツールはモチーフを大文字に変換するため、生成されるパターンは大文字の配列に一致します。小文字の塩基にもマッチさせたい場合は、正規表現エンジンで大文字小文字を区別しないフラグを追加してください。`)
};

const zh_iupac_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转换器会将模体转为大写，因此生成的模式匹配大写序列。如果你也需要匹配小写碱基，请在你的正则表达式引擎中添加不区分大小写的标志。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iupac_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iupac_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iupac_faq_a4", locale)
	if (locale === "en") return en_iupac_faq_a4(inputs)
	if (locale === "es") return es_iupac_faq_a4(inputs)
	if (locale === "de") return de_iupac_faq_a4(inputs)
	if (locale === "nl") return nl_iupac_faq_a4(inputs)
	if (locale === "fr") return fr_iupac_faq_a4(inputs)
	if (locale === "it") return it_iupac_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_iupac_faq_a4(inputs)
	if (locale === "pt") return pt_iupac_faq_a4(inputs)
	if (locale === "ja") return ja_iupac_faq_a4(inputs)
	return zh_iupac_faq_a4(inputs)
};